import { render } from "./admin-navbar.vue?vue&type=template&id=571fcf87"
import script from "./admin-navbar.vue?vue&type=script&lang=js"
export * from "./admin-navbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__